import React, { useEffect,useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";
import { fetchStockDashboardData } from "../../../../redux/reducers/stockDashboardSlice";
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ 
        backgroundColor: "#2C2C49",
        padding: "8px 12px",
        borderRadius: "6px",
        color: "#fff",
        fontSize: "12px",
        fontWeight: "500",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
      }}>
        <div>{payload[0].payload.name}</div>
        <div style={{ color: "#FFD700", marginTop: "2px" }}>
          Stock: {payload[0].payload.count || payload[0].value}
        </div>
      </div>
    );
  }
  return null;
};

// Custom tick component to ensure single line text
const CustomYAxisTick = (props) => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text 
        x={0} 
        y={0} 
        dy={4} 
        textAnchor="end" 
        fill="#2C2C49"
        fontSize="13"
        fontWeight="500"
        style={{ 
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {payload.value}
      </text>
    </g>
  );
};

const LowStockAlerts = () => {
  const dispatch = useDispatch();
  const { lowStocksLevel, lowStocks, loading, error } = useSelector(
    (state) => state.stockDashboard
  );

  const [lowStockData, setLowStockData] = useState([]);
  const [total, setTotal] = useState(0);
  const [criticalCount, setCriticalCount] = useState(0);
  const [cautionCount, setCautionCount] = useState(0);

  // Enhanced color palette with light, vibrant colors
  const colorPalette = [
    "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7",
    "#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9",
    "#F1948A", "#82E0AA", "#F8C471", "#85C1E9", "#D7DBDD"
  ];

  useEffect(() => {
    dispatch(fetchStockDashboardData());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!lowStocksLevel || !Array.isArray(lowStocksLevel)) return;

  //   const formatted = lowStocksLevel.map((item, index) => ({
  //     name: item.tradeName,
  //     value: item.count,
  //     count: item.count,
  //     color: colorPalette[index % colorPalette.length],
  //     category: item.count <= 2 ? "Critical" : "Caution"
  //   }));

  //   const critical = formatted.filter(item => item.category === "Critical").length;
  //   const caution = formatted.filter(item => item.category === "Caution").length;

  //   setLowStockData(formatted);
  //   setTotal(lowStocks || formatted.length);
  //   setCriticalCount(critical);
  //   setCautionCount(caution);
  // }, [lowStocksLevel, lowStocks]);
useEffect(() => {
  if (!lowStocksLevel || !Array.isArray(lowStocksLevel)) return;

  const formatted = lowStocksLevel.map((item) => {
    const category = item.count <= 2 ? "Critical" : "Caution";
    const color = category === "Critical" ? "#FF3B30" : "#FFB200"; // Red & Yellow

    return {
      name: item.tradeName,
      value: item.count,
      count: item.count,
      color,
      category
    };
  });

  const critical = formatted.filter(item => item.category === "Critical").length;
  const caution = formatted.filter(item => item.category === "Caution").length;

  setLowStockData(formatted);
  setTotal(lowStocks || formatted.length);
  setCriticalCount(critical);
  setCautionCount(caution);
}, [lowStocksLevel, lowStocks]);

  if (loading && !lowStockData.length)
    return <p>Loading low stock alerts...</p>;

  if (error)
    return <p>Error: {error}</p>;

  return (
    <div style={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "24px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      maxWidth: "1200px",
      margin: "auto",
      fontFamily: "'Inter', 'Segoe UI', sans-serif"
    }}>
      <div style={{ 
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "20px"
      }}>
        <div>
          <h3 style={{ 
            margin: "0 0 12px 0",
            fontSize: "16px",
            color: "#2C2C49",
            fontWeight: "600"
          }}>
            Low Stock Alerts
          </h3>
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ 
                 width: "12px", 
  height: "12px", 
  borderRadius: "50%", 
  backgroundColor: "#FF3B30", 
                border: "2px solid #fff",
                boxShadow: "0 2px 4px rgba(255,107,107,0.3)"
              }} />
              <span style={{ fontSize: "13px", color: "#666", fontWeight: "500" }}>
                Critical ({criticalCount})
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ 
               width: "12px", 
  height: "12px", 
  borderRadius: "50%", 
  backgroundColor: "#FFB200", 
                border: "2px solid #fff",
                boxShadow: "0 2px 4px rgba(78,205,196,0.3)"
              }} />
              <span style={{ fontSize: "13px", color: "#666", fontWeight: "500" }}>
                Caution ({cautionCount})
              </span>
            </div>
            {/* <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ 
                width: "12px", 
                height: "12px", 
                borderRadius: "2px", 
                background: "linear-gradient(45deg, #FF6B6B, #4ECDC4, #45B7D1, #96CEB4)",
                border: "2px solid #fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }} />
              <span style={{ fontSize: "13px", color: "#666", fontWeight: "500" }}>
                Varied Colors
              </span>
            </div> */}
          </div>
        </div>
        <div style={{
          backgroundColor: "#F8F9FA",
          padding: "12px 20px",
          borderRadius: "8px",
          border: "2px solid #E9ECEF"
        }}>
          <span style={{ 
            fontSize: "14px", 
            color: "#666",
            fontWeight: "500"
          }}>
            Total Items:
          </span>
          <span style={{ 
            fontSize: "18px", 
            color: "#2C2C49",
            fontWeight: "700",
            marginLeft: "8px"
          }}>
            {total}
          </span>
        </div>
      </div>

      <div style={{
        backgroundColor: "#FAFBFC",
        borderRadius: "8px",
        padding: "16px",
        border: "1px solid #E9ECEF"
      }}>
        <BarChart
          width={1000}
          height={Math.max(250, lowStockData.length * 45)}
          data={lowStockData}
          layout="vertical"
          margin={{ top: 15, right: 40, left: 220, bottom: 15 }}
        >
          <XAxis 
            type="number" 
            hide
            domain={[0, 'dataMax + 1']}
          />
          <YAxis 
            type="category"
            dataKey="name"
            tick={<CustomYAxisTick />}
            width={200}
            interval={0}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip 
            content={<CustomTooltip />} 
            cursor={{ fill: "rgba(0,0,0,0.02)" }}
          />
          <Bar 
            dataKey="value" 
            barSize={16} 
            radius={[8, 8, 8, 8]}
          >
            {lowStockData.map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={entry.color}
                style={{
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }}
              />
            ))}
          </Bar>
        </BarChart>
      </div>
    </div>
  );
};

export default LowStockAlerts;